import { clsx } from "clsx";
import { extendTailwindMerge } from "tailwind-merge"

// Teach tailwind-merge the foundation's custom scales (tailwind.config.js) so that
// `cn('rounded-control', 'rounded-full')` resolves to `rounded-full` like built-in sizes do.
const twMerge = extendTailwindMerge({
  extend: {
    theme: {
      radius: ["card", "control"],
      shadow: ["card", "raised", "overlay", "focus"],
    },
  },
})

export function cn(...inputs) {
  return twMerge(clsx(inputs));
}
